import React from "react";
import CustomButton from "../CustomButton";
import { useNavigate } from "react-router-dom";
import { ButtonProps } from "@mui/material/Button";
import { SvgIconType } from "../../helpers/SvgIcon";

function FormButtons({
  goBackLabel,
  goNextLabel,
  handleGoBack,
  handleGoNext,
  nextButtonDisabled,
  nextButtonLoading,
  nextButtonType = "submit",
  nextButtonVariant = "contained",
  nextButtonIcon,
}: {
  goBackLabel?: string;
  goNextLabel?: string;
  handleGoBack?: () => void;
  handleGoNext?: () => void;
  nextButtonDisabled?: boolean;
  nextButtonLoading?: boolean;
  nextButtonType?: "submit" | "button";
  nextButtonVariant?: ButtonProps["variant"];
  nextButtonIcon?: SvgIconType;
}) {
  const navigate = useNavigate();

  const goBack = () => {
    if (handleGoBack) {
      handleGoBack();
      return;
    }
    navigate(-1);
  };

  return (
    <div className="mt-6 flex flex-wrap items-center justify-between gap-3">
      {goBackLabel && (
        <CustomButton variant="outlined" onClick={goBack}>
          {goBackLabel}
        </CustomButton>
      )}
      {goNextLabel && (
        <CustomButton
          variant={nextButtonVariant}
          icon={nextButtonIcon}
          type={nextButtonType}
          disabled={nextButtonDisabled}
          loading={nextButtonLoading}
          onClick={handleGoNext}>
          {goNextLabel}
        </CustomButton>
      )}
    </div>
  );
}

export default FormButtons;
